import { render, staticRenderFns } from "./BbeeProductosServiciosCC.vue?vue&type=template&id=abc75ac0"
import script from "./BbeeProductosServiciosCC.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports